import { useRef, useState } from 'react'

export const useLatest = <T>(value: T) => {
  const ref = useRef(value)
  ref.current = value
  return ref
}

export type LatestRequest = {
  start: () => () => boolean
  cancel: () => void
}

export const createLatestRequest = (): LatestRequest => {
  let current = 0
  return {
    start: () => {
      const token = ++current
      return () => token === current
    },
    cancel: () => {
      current += 1
    },
  }
}

export const useLatestRequest = (): LatestRequest => useState(createLatestRequest)[0]
